var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import UserService from "../services/user";
import GreenfieldService from "../services/greenfield";
import { prodApiUrl } from "../utils/constants";
export class UserController {
    /**
     *
     * @param baseUrl api url
     * @param triaName default triaName for all functions
     * @param environment mainnet or testnet
     */
    constructor(baseUrl = prodApiUrl, triaName, environment = "mainnet") {
        this.baseUrl = baseUrl;
        this.user = new UserService(baseUrl, environment);
        this.greenfield = new GreenfieldService(baseUrl);
        this.triaName = triaName;
    }
    searchAssets(term) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.searchAssets({ term });
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    searchUser(term, page, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.searchUser({ term, page, limit });
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getAllHistory() {
        return __awaiter(this, arguments, void 0, function* (filter = "all", filterChainNames, triaName) {
            try {
                const res = yield this.user.getAllHistory((this.triaName || triaName), filter, filterChainNames);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getOnChainConversation(withTriaName, triaName, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getOnChainConversation((this.triaName || triaName), withTriaName, filters);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getAssets(filterChainNames, filter, sort, triaName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getAssets((this.triaName || triaName), filterChainNames, filter, sort);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getAssetsForATriaName(triaName, filterChainNames, sort) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getAssetsForATriaName(triaName, filterChainNames, sort);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getAssetBalanceForATriaName(triaName, chainName, tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getAssetBalanceForATriaName(triaName, chainName, tokenAddress);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getAssetDetailsV2(_a) {
        return __awaiter(this, arguments, void 0, function* ({ chain, tokenAddress, triaName, accessToken, }) {
            try {
                const res = yield this.user.getAssetDetailsV2({
                    triaName: (this.triaName || triaName),
                    chain,
                    tokenAddress,
                    accessToken,
                });
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getAssetDetails(_a) {
        return __awaiter(this, arguments, void 0, function* ({ chain, tokenAddress, triaName, type, accessToken, }) {
            try {
                const res = yield this.user.getAssetDetails({
                    triaName: (this.triaName || triaName),
                    chain,
                    tokenAddress,
                    type,
                    accessToken,
                });
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getAssetHistory(chainName, tokenAddress, triaName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getAssetHistory((this.triaName || triaName), chainName, tokenAddress);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getNFTs() {
        return __awaiter(this, arguments, void 0, function* (sort = "Descending buy date", filter, filterByCollectionId, filterChainNames, triaName, type) {
            try {
                const res = yield this.user.getNFTs((this.triaName || triaName), sort, filter, filterByCollectionId, filterChainNames, type);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getNFTCollections(filterChainNames, triaName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getNFTCollections((this.triaName || triaName), filterChainNames);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getNFTDetails(chainName, tokenAddress, tokenId, triaName, type, includeAmount, customChain, isCustom, isErc721) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getNFTDetails((this.triaName || triaName), chainName, tokenAddress, tokenId, type, includeAmount, customChain, isCustom, isErc721);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getUserByAddress(address, chainName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getUserByAddress(address, chainName);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getAddressByChainName(triaName, chainName, type) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getAddressByChainName(triaName, chainName, type);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    convertToken(chainName, fromToken, fromAmount, toToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.convertToken(chainName, fromToken, fromAmount, toToken);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getRampnalysisUrl(address, coinSymbol) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getRampnalysisUrl(address, coinSymbol);
                return res;
            }
            catch (err) {
                return { success: false, url: null };
            }
        });
    }
    getRampnalysisSupportedToken(query) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getRampnalysisSupportedToken(query);
                return res;
            }
            catch (err) {
                return { success: false, data: null };
            }
        });
    }
    getAllNetworks() {
        return __awaiter(this, arguments, void 0, function* (type = "EOA") {
            try {
                const res = yield this.user.getAllNetworks(type);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getAssetChart(timePeriod, chainName, tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getAssetChart(timePeriod, chainName, tokenAddress);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getTotalBalanceV2(triaName, filterChainNames) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getTotalBalanceV2((this.triaName || triaName), filterChainNames);
                return res;
            }
            catch (err) {
                return { success: false, message: "Unable to fetch total balance" };
            }
        });
    }
    getTotalBalance(triaName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getTotalBalance((this.triaName || triaName));
                return res;
            }
            catch (err) {
                return { success: false, message: "Unable to fetch total balance" };
            }
        });
    }
    getAvatar(accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getAvatar(accessToken);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    postAccountCreationData(triaName, accessToken, encyRandomNumber, recoveryShard, salt, IdToken, input, fromClientId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.postAccountCreationData(triaName, accessToken, encyRandomNumber, recoveryShard, salt, IdToken, input, fromClientId);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    updateAvatar(accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.updateAvatar(accessToken);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getPopularToken() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getPopularToken();
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    searchBuyToken(tokenName, currentChainName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.searchBuyToken(tokenName, currentChainName);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    addUserActivity(triaName, sentToTriaName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.addUserActivity(triaName, sentToTriaName);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getRecentUsersForUser(triaName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getRecentUsersForUser(triaName);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    deleteARecentUser(user, recentUser) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.deleteARecentUser(user, recentUser);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    isRecoveryShardSetup(accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.isRecoveryShardSetup(accessToken);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    setupRecoveryShard(_a) {
        return __awaiter(this, arguments, void 0, function* ({ pin, shard, encyRandomNumber, derivedKeySalt, accessToken, }) {
            try {
                const res = yield this.user.setupRecoveryShard({
                    pin,
                    shard,
                    encyRandomNumber,
                    derivedKeySalt,
                    accessToken,
                });
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    fundWallet(_a) {
        return __awaiter(this, arguments, void 0, function* ({ walletAddress, origin, }) {
            try {
                const res = yield this.user.fundWallet({ walletAddress, origin });
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    uploadGreenfield(_a) {
        return __awaiter(this, arguments, void 0, function* ({ triaName }) {
            try {
                const res = yield this.greenfield.upload(triaName);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    fetchGreenfield(_a) {
        return __awaiter(this, arguments, void 0, function* ({ triaName }) {
            try {
                const res = yield this.greenfield.fetch(triaName);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getNativeTokenPrice(chainName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getNativeTokenPrice(chainName);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getTwitterFeed(accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = (yield this.user.getTwitterFeed(accessToken));
            if (res.success) {
                return res;
            }
            else {
                return res;
            }
        });
    }
    getUserPrefs(accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getUserPrefs(accessToken);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    addCustomChain(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accessToken, customChain, }) {
            try {
                const res = yield this.user.addCustomChain({ accessToken, customChain });
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    updateCustomChain(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accessToken, customChain, }) {
            try {
                const res = yield this.user.updateCustomChain({
                    accessToken,
                    customChain,
                });
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    deleteCustomChain(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accessToken, customChain, }) {
            try {
                const res = yield this.user.deleteCustomChain({
                    accessToken,
                    customChain,
                });
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    addCustomToken(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accessToken, customToken, }) {
            try {
                const res = yield this.user.addCustomToken({
                    accessToken,
                    customToken,
                });
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    updateCustomToken(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accessToken, customToken, }) {
            try {
                const res = yield this.user.updateCustomToken({
                    accessToken,
                    customToken,
                });
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getSuggestedDapps() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getSuggestedDapps();
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    getNotificationPreference() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.getNotificationPreference();
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    updateNotificationPreference(notificationPreferences) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.updateNotificationPreference(notificationPreferences);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    updateSwapPreference(swapPreferences, accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.user.updateSwapPreference(swapPreferences, accessToken);
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    deleteCustomToken(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accessToken, customToken, }) {
            try {
                const res = yield this.user.deleteCustomToken({
                    accessToken,
                    customToken,
                });
                return res;
            }
            catch (err) {
                return err;
            }
        });
    }
    addCustomNft(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.user.addCustomNft(Object.assign(Object.assign({}, params.nft), { accessToken: params.accessToken }));
            }
            catch (err) {
                throw err;
            }
        });
    }
    updateCustomNft(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.user.updateCustomNft(Object.assign(Object.assign({ id: params.id }, params.nft), { accessToken: params.accessToken }));
            }
            catch (err) {
                throw err;
            }
        });
    }
    deleteCustomNft(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.user.deleteCustomNft(params.id, params.accessToken);
            }
            catch (err) {
                throw err;
            }
        });
    }
    getCustomNfts(accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.user.getAllCustomNfts(accessToken);
            }
            catch (err) {
                throw err;
            }
        });
    }
    getCustomNft(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.user.getCustomNft(params.id, params.accessToken);
            }
            catch (err) {
                throw err;
            }
        });
    }
}
